import { AppPlatform } from '@trinity/chat';
import { type HomePage } from '@trinity/management-app-client';
import { RefGroupTypeEnum, RefRoleEnum  } from '@trinity/management-app-client/enums';
import { config } from '@/config';
import { useAppSelector } from './store';

export const useIsDemoGroup = () => {
  return useAppSelector(state => state.group.typeId === RefGroupTypeEnum.Demo);
};

export const useHasWorkspacesEnabled = () => {
  return useAppSelector(state => state.features.workspaces);
};

export const useHasHcpProfilesEnabled = () => {
  return useAppSelector(state => state.features.hcpProfiles);
};

export const useHasChatVoiceInputEnabled = () => {
  return useAppSelector(state => state.features.chatVoiceInput);
};

export const useHasChatReadAloudEnabled = () => {
  return useAppSelector(state => state.features.chatReadAloud);
};

export const useHasChatVoiceModeEnabled = () => {
  return useAppSelector(state => state.features.chatVoiceMode);
};

export const useHasPredictiveScheduling = () => {
  return useAppSelector(state => state.features.predictiveScheduling);
};

export const useHasSmartRouting = () => {
  return useAppSelector(state => state.features.smartRouting);
};

export const useSpeechServicesProvider = () => {
  const speechServicesProvider = useAppSelector(state => state.features.speechServicesProvider);
  if (config().APP_PLATFORM === AppPlatform.enum.veeva) return 'custom';
  return speechServicesProvider;
};

export const useEngagementLabels = () => {
  return useAppSelector(state => state.features.engagementResponseLabels);
};

export const useHasDataStewardRole = () => {
  //This role might be obsolete and not used in this repo
  return false;
};

export const useIsInternalUser = () => {
  return useAppSelector(state => state.user.roles.includes(RefRoleEnum.SystemAdmin));
};

export const useCanPublish = () => {
  // Placeholder gate for publish/unpublish/hide/unhide actions, mirroring chat-api's
  // canManagePublishState(). Always true today because chat-api has no server-side
  // "internal user" concept yet to check against. Single toggle point for later.
  return true;
};

export const useCanViewUnpublished = () => {
  // Placeholder gate for seeing draft (unpublished) content, alongside useCanPublish. Always true
  // today while permissions are being incorporated. Single toggle point for later.
  return true;
};

export const useSelectGroup = () => {
  return useAppSelector(state => state.group);
};

export const useSelectUser = () => {
  return useAppSelector(state => state.user);
};

export const useSelectWorkspaces = () => {
  return useAppSelector(state => state.workspace);
};

export const useSelectHomePageLocation = () => {
  const homeScreen = useAppSelector(state => state.features.homeScreen);

  const homePage: Record<HomePage, string> = {
    ['chat']: '/chat',
    ['analyst-main']: '/main',
    ['workspace']: '/workspaces',
  };
  return homeScreen ? homePage[homeScreen] : '/home';
};